<template>
  <div style="text-align:center;padding-top:100px;height:100%;">
    <div class="loginBox" style="border:1px solid #ddd;margin:0 auto;display:inline-block;">
      <div class="header" style="height:40px;"></div>
      <div style="padding:30px;">
        <div style="margin-bottom:20px;">
          <span>登录类型：</span>
          <el-radio v-model="loginType" label="1">成员代码</el-radio>
          <el-radio v-model="loginType" label="2">成员简称</el-radio>
        </div>
        <div style="margin-bottom:20px;">
          <span v-if="loginType=='1'">成员代码：</span>
          <span v-else>成员简称：</span>
          <el-input
            size="medium"
            style="width:200px;"
            class="input"
            v-model="organFlag"
            :placeholder="loginType==1?'请输入成员代码':'请输入成员简称'"
          ></el-input>
        </div>
        <div style="margin-bottom:20px;">
          <span>用户账号：</span>
          <el-input
            size="medium"
            style="width:200px;"
            class="input"
            v-model="userCode"
            placeholder="请输入用户账号"
          ></el-input>
        </div>
        <div style="margin-bottom:20px;">
          <span>用户密码：</span>
          <el-input
            style="width:200px;"
            size="medium"
            class="input"
            show-password
            v-model="password"
            placeholder="请输入用户密码"
          ></el-input>
        </div>
        <div>
          <el-button type="primary" size="medium" :loading="loading" @click="login">登录</el-button>
        </div>
        <div>
          <el-dropdown style="margin-left:20px;float:right;">
            <span class="el-dropdown-link" style="color:#1890ff;font-size:14px;
          ">
              注册
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="padding:0 20px;">
                <router-link :to="{ name: 'registerComUser' }">成员注册</router-link>
              </el-dropdown-item>
              <el-dropdown-item style="padding:0 20px;">
                <router-link :to="{ name: 'registerUser' }">用户注册</router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <router-link :to="{ name: 'forgetPassword' }">
            <span style="float:left;font-size:14px;color:#666;
          ">忘记密码</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/home";
const setCookie = (name, value) => {
  var exp = new Date();
  exp.setTime(exp.getTime() + 24 * 60 * 60 * 1000);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
};
export default {
  data() {
    return {
      loginType: "1",
      loading: false,
      mobileCode: undefined,
      password: undefined,
      organFlag: undefined,
      userCode: undefined
    };
  },
  methods: {
    login() {
      if (!this.organFlag) {
        if (this.loginType == "1") {
          this.$message.error("请输入成员代码");
        } else {
          this.$message.error("请输入成员简称");
        }
        return;
      }
      if (!this.userCode) {
        this.$message.error("请输入用户账号");
        return;
      }
      if (!this.password) {
        this.$message.error("请输入密码");
        return;
      }
      this.loading = true;
      login({
        op: "login",
        organFlag: this.organFlag,
        userCode: this.userCode,
        password: this.password,
        loginType: this.loginType,
        doLogin: 1
      }).then(res => {
        if (res.success) {
          this.$message({
            message: "登录成功！",
            type: "success"
          });
          setCookie("organFlag", this.organFlag);
          setCookie("userCode", this.userCode);
          setCookie("password", this.password);
          setCookie("loginType", this.loginType);
          setTimeout(res => {
            this.$router.push({
              path: "/home"
            });
          }, 1000);
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style  lang="less" scoped>
.header {
  background: #1890ff;
  // background: -ms-linear-gradient(top, #297603, #67c23a); /* IE 10 */
  // background: -moz-linear-gradient(top, #297603, #67c23a); /*火狐*/
  // background: -webkit-gradient(
  //   linear,
  //   0% 0%,
  //   0% 100%,
  //   from(#297603),
  //   to(#67c23a)
  // ); /* Safari 4-5, Chrome 1-9*/
  // background: -webkit-linear-gradient(
  //   top,
  //   #297603,
  //   #67c23a
  // ); /*Safari5.1 Chrome 10+*/
  // background: -o-linear-gradient(top, #297603, #67c23a); /*Opera 11.10+*/
  // background: linear-gradient(to bottom, #297603 0%, #67c23a 100%);
}
.loginBox {
  border-radius: 5px;
  overflow: hidden;
  font-size: 14px;
  background: #fff;
}
</style>